////////////////////////////////////////////////////////////
//                                                        //
//  Program: Activity.jsx                                 //
//  Application: Igloo                                    //
//  Option: List Igloo lock/unlock activity logs          //
//  Developer: Ravi                                       //
//                                                        //
////////////////////////////////////////////////////////////

import React, { Component } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import SimpleReactValidator from "simple-react-validator";
import IglooService from "../../../services/IglooService";
import { Container } from "react-bootstrap";
import Moment from "moment";

export class Activity extends Component {
  constructor(props) {
    super(props);

    this.validator = new SimpleReactValidator({ autoForceUpdate: this });

    this.state = {
      showSpinner: false,
      loading: false,
      showAlertModal: false,
      alertModalType: "",
      alertModalTitle: "",
      alertModalMessage: "",
      input: {},
      errors: {},
      tableQueryString: "",
      customQueryString: "",
      isSearch: global.isSearch,
      is_search: 0,
      module_search: "",
      filter_value: "",
      total_record: 0,
      records: [],
      property_slug: this.props.match
        ? this.props.match.params.propertySlug ||
          this.props.match.params.outsidePropertySlug
        : "",
      config: {
        sort: {
          column: "entry_date",
          order: "desc",
        },
        key_column: "igloo_activity_log_id",
        page_size: global.page_size,
        length_menu: global.page_length_menu,
        show_length_menu: true,
        show_filter: global.show_filter,
        show_pagination: global.show_pagination,
        pagination: "advance",
        button: {
          excel: global.excel_button,
          print: global.print_button,
          extra: false,
        },
        language: {
          no_data_text: "No data found",
        },
      },
      columns: [
        {
          key: "status_time",
          text: "Time",
          className: "status_time hand-cursor date_tbl_formate",
          sortable: true,
          cell: (record) => {
            return record.status_time
              ? Moment(record.status_time).format(global.dateTimeFormat)
              : record.entry_date_utc
              ? Moment(record.entry_date_utc).format(global.dateTimeFormat)
              : "";
          },
        },
        {
          key: "activity",
          text: "Activity",
          className: "activity hand-cursor",
          sortable: false,
          cell: (record) => {
            return record.activity ? record.activity : "";
          },
        },
        {
          key: "device_name",
          text: "Device Name",
          className: "device_name hand-cursor",
          sortable: true,
          cell: (record) => {
            return record.device_name ? record.device_name : "";
          },
        },
        {
          key: "lock_id",
          text: "Serial Number",
          className: "lock_id hand-cursor",
          sortable: true,
          cell: (record) => {
            return record.lock_id ? record.lock_id : "";
          },
        },
        {
          key: "pin",
          text: "PIN",
          className: "pin hand-cursor",
          sortable: false,
          cell: (record) => {
            return record.pin ? record.pin : "";
          },
        },
        {
          key: "unit_name",
          text: "Unit",
          className: "unit_name hand-cursor",
          sortable: true,
          cell: (record) => {
            return record.unit_name
              ? record.unit_name
              : record.unit_number
              ? record.unit_number
              : "";
          },
        },
      ],
    };
  }

  async componentDidMount() {
    await this.getData();
  }

  async getData(queryString = "") {
    this.setState({ showSpinner: true, loading: true });
    var list = [];
    var totalRecords = 0;

    let res = await IglooService.getIglooActivity(
      "property_slug=" +
        (this.state.property_slug ? this.state.property_slug : "") +
        (queryString ? "&" + queryString : "")
    );

    if (global.successStatus.includes(res.status)) {
      list = res.data ? res.data.data : [];
      totalRecords = res.data ? res.data.total : 0;
    }

    this.setState({
      total_record: totalRecords,
      records: list,
      showSpinner: false,
      loading: false,
    });
  }

  tableChangeHandler = (data) => {
    let queryString = Object.keys(data)
      .map((key) => {
        if (key === "sort_order" && data[key]) {
          return (
            encodeURIComponent("sort_order") +
            "=" +
            encodeURIComponent(data[key].order) +
            "&" +
            encodeURIComponent("sort_column") +
            "=" +
            encodeURIComponent(data[key].column)
          );
        } else {
          let newKey = key;
          if (key === "page_number") {
            newKey = "page";
            window.scrollTo(0, 0);
          } else if (key === "page_size") {
            newKey = "per_page";
          } else if (key === "sort_order") {
            data[key] = "asc";
          }
          return (
            encodeURIComponent(newKey) + "=" + encodeURIComponent(data[key])
          );
        }
      })
      .join("&");

    if (data.filter_value !== "") {
      this.setState({ tableQueryString: queryString });
    } else {
      queryString += "&" + this.state.customQueryString;
      this.setState({ tableQueryString: queryString });
    }

    if (data.filter_value !== this.state.filter_value) {
      clearTimeout(this.state.filter_time);
      this.setState({
        filter_time: setTimeout(
          () => this.getData(queryString),
          global.filter_time
        ),
        filter_value: data.filter_value,
      });
    } else {
      this.getData(queryString);
    }
  };

  render() {
    return (
      <>
        <main>
          <Container className="innter-container">
            <div className="d-flex flex-column">
              <div className="row row-xs mg-t-0 pd-t-0 pd-lg-l-15 pd-xs-l-0">
                <div className="col-md-12 mg-t-10 mg-b-10">
                  <div className="dashbaord-pageHeadertitle d-flex justify-content-between align-items-center flex-wrap mg-b-0">
                    <h3>Igloo Activity</h3>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="scrolling-carousel">
                    <div className="dashboardRightcard background-none pt-0 pd-l-30 pd-r-30">
                      <div className="mg-t-18 brandList pd-l-15 pd-r-15 d-block">
                        <div className="pd-lg-l-0 pd-xs-l-15">
                          <ReactDatatable
                            className="table no-wrap mg-b-30 pd-b-2 text-align-left"
                            config={this.state.config}
                            records={this.state.records}
                            columns={this.state.columns}
                            extraButtons={[]}
                            dynamic={true}
                            total_record={this.state.total_record}
                            onChange={this.tableChangeHandler}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </main>
      </>
    );
  }
}

export default Activity;
